/**
 * Increase/Decrease the count in the header
 */
const updateCartCount = () => {
  /**
   * @param {HTMLElement}
   */
  const counts = document.querySelectorAll("[data-count-js]");

  for (let i = 0; i < counts.length; i++) {
    counts[i].textContent =
      window.liquidAjaxCart.cart.item_count > 0
        ? window.liquidAjaxCart.cart.item_count
        : "";
  }
};

/**
 * Open the cart modal
 */
const openCart = () => {
  /**
   * @param {HTMLDialogElement | null}
   * the modal of the cart
   */
  const modal = document.querySelector("[data-js-cart]");

  modal?.show();
};

// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.cartDrawer = function () {
  /**
   * @var {Record<string, string>}
   * A list of classes used as CSS styling hooks
   */
  const classes = {
    cartOpen: "is-cart",
  };

  /**
   * @param {HTMLElement}
   */
  const openButtons = document.querySelectorAll("[data-js-open-cart]");

  /**
   * @param {HTMLElement}
   */
  const closeButtons = document.querySelectorAll("[data-js-close-cart]");

  /**
   * @param {HTMLDialogElement | null}
   * the modal of the cart
   */
  const modal = document.querySelector("[data-js-cart]");

  /**
   * Work out whether to show/hide the cart modal based on its current status
   * when the toggle button is clicked
   *
   * @returns {void}
   */
  const handleOpenButtonClick = (event) => {
    event.preventDefault();

    if (modal?.open) {
      close();
    } else {
      open();
    }
  };

  /**
   * Open the cart modal
   *
   * @returns {void}
   */
  const open = () => {
    if (window.AndDaughter.headerScroll) {
      document.documentElement.classList.add(
        window.AndDaughter.headerScroll().classes.scrollDowned
      );
    }
    document.documentElement.classList.add(classes.cartOpen);

    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i]?.setAttribute("aria-expanded", "true");
    }

    modal?.show();

    if (!document.querySelector('body[data-test-cart-gamification="true"]')) {
      return;
    }

    const GAMI_DELAY_MS = 2000;
    const gami = document.querySelector("cart-gami");
    if (gami) {
      setTimeout(function () {
        gami.onInitCart();
        let gamiE = document.querySelector(".cart-drawer__gamification");
        if (gamiE) {
          // console.log("as", gamiE);
          gamiE.setAttribute("data-show", true);
        }
      }, GAMI_DELAY_MS);
    }
  };

  /**
   * Close the open cart modal
   *
   * @returns {void}
   */
  const close = () => {
    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i]?.setAttribute("aria-expanded", "false");
    }
    modal?.close();
    document.documentElement.classList.remove(classes.cartOpen);
  };

  /**
   * Handle keydown events, only used to handle Esc key which should close the modal
   * @param {KeyboardEvent} event
   *
   * @return {void}
   */
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // if esc key was not pressed in combination with ctrl or alt or shift
      const isCombinedKey = event.ctrlKey || event.altKey || event.shiftKey;
      if (!isCombinedKey && modal?.open) {
        close();
        for (let i = 0; i < openButtons.length; i++) {
          if (openButtons[i]?.checkVisibility()) {
            openButtons[i]?.focus();
            break;
          }
        }
      }
    }
  };

  /**
   * Detects a click inside or outside the component
   * @param {Event} event
   *
   * @return {void}
   */
  const handleClick = (event) => {
    if (
      !modal?.open ||
      (event.target?.closest("a") &&
        event.target?.closest("a").getAttribute("aria-controls") ===
          "cart-side")
    ) {
      return;
    }

    const isClickInside = modal?.contains(event.target);

    if (!isClickInside) {
      close();
    }

    if (
      event.target.getAttribute("data-js-close-cart")?.toString() === "true"
    ) {
      close();
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    if (
      !modal ||
      !openButtons ||
      openButtons.length === 0 ||
      !closeButtons ||
      !closeButtons.length === 0
    ) {
      return;
    }

    // Open
    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i].removeEventListener("click", handleOpenButtonClick);
      openButtons[i].addEventListener("click", handleOpenButtonClick);
    }

    // Press Esc = close
    document.removeEventListener("keydown", handleKeyDown);
    document.addEventListener("keydown", handleKeyDown);

    // Click outside the cart to close it
    document.removeEventListener("click", handleClick);
    document.addEventListener("click", handleClick);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
  };

  return {
    close,
    init,
    open,
  };
};

window.AndDaughter.cartDrawer().init();

window.addEventListener("DOMContentLoaded", () => {
  /** gamification **/
  class CartGami extends HTMLElement {
    constructor() {
      super();
      this.location = null;
      this.rewards = null;
      this.bar = null;
      this.currency = {
        DE: "EUR",
        AU: "AUD",
        CH: "CHF",
        US: "USD",
      };
      this.checkEle = {
        active: this.querySelector(".cart-drawer__gamification-check--active"),
        inactive: this.querySelector(
          ".cart-drawer__gamification-check--inactive"
        ),
      };

      this.textElement = {
        still: this.querySelector(".cart-drawer__gamification-message--still"),
        complete: this.querySelector(
          ".cart-drawer__gamification-message--complete"
        ),
        price: undefined,
      };

      if (this.textElement.still) {
        this.textElement.price = this.textElement.still.querySelector(
          'span[data-value="until-price"]'
        );
      }
    }

    async connectedCallback() {
      this.location = await this.getLocation();
      this.rewards = this.parseRewards();
      this.bar = this.querySelector(
        ".cart-drawer__gamification-progress .cart-drawer__gamification-progress--bard"
      );
      this.onInitCart();
      // console.log("h", this.location);
    }

    parseRewards() {
      let textContent = this.querySelector(".rewards").textContent;
      return JSON.parse(textContent);
    }

    getTier() {
      const vw = this;
      const tier = this.rewards.rewards.filter(
        (item) => item.country == vw.location.countryCode
      );
      return tier;
    }

    comprobeCurrency() {
      return "";
    }

    onInitCart(event) {
      this.updateBar();
    }

    updateBar() {
      let ammount = window.liquidAjaxCart.cart.total_price / 100.0;
      let obj = this.getTier();

      if (obj.length == 0) {
        this.setAttribute("data-show", "false");
        document
          .querySelector(".cart-drawer__upsell")
          ?.setAttribute("data-show", "false");

        return false;
      } else if (
        obj.length > 0 &&
        this.currency[obj[0].country] != Shopify.currency.active
      ) {
        this.setAttribute("data-show", "false");
        document
          .querySelector(".cart-drawer__upsell")
          ?.setAttribute("data-show", "false");

        return false;
      } else {
        this.setAttribute("data-show", "true");
        document
          .querySelector(".cart-drawer__upsell")
          ?.setAttribute("data-show", "true");
      }

      let { reach } = obj[0];
      let sustraction = reach - ammount;

      let ruleOf = (ammount / reach) * 100;

      let percent = Math.min(ruleOf, 100);

      if (ruleOf >= 100) {
        this.checkEle.active.setAttribute("data-active", true);
        this.checkEle.inactive.setAttribute("data-active", false);
        this.textElement.complete.setAttribute("data-show", true);
        this.textElement.still.setAttribute("data-show", false);
      } else {
        this.checkEle.active.setAttribute("data-active", false);
        this.checkEle.inactive.setAttribute("data-active", true);
        this.textElement.complete.setAttribute("data-show", false);
        this.textElement.still.setAttribute("data-show", true);
      }

      this.textElement.price.textContent =
        Shopify?.currency?.active + " " + sustraction;

      this.bar.style.width = percent + "%";
    }

    onChangeCart(event) {
      const UPDATE_BAR_DELAY_MS = 5000;
      setTimeout(() => {
        this.updateBar();
      }, UPDATE_BAR_DELAY_MS);
    }

    async getLocation() {
      try {
        const request = await fetch(
          "https://us-central1-functions-358315.cloudfunctions.net/location"
        );
        const response = await request.json();
        return response;
      } catch (error) {
        console.error(error);
        return undefined;
      }
    }
  }

  window.customElements.define("cart-gami", CartGami);
});

function runWhenInit() {
  window.liquidAjaxCart.conf("updateOnWindowFocus", false);
  // console.log("The current cart state is: ", window.liquidAjaxCart.cart);
  if (!document.querySelector('body[data-test-cart-gamification="true"]')) {
    return;
  }
  const GAMI_DELAY_MS = 2000;
  const gami = document.querySelector("cart-gami");
  if (gami) {
    setTimeout(function () {
      gami.onInitCart();
    }, GAMI_DELAY_MS);
  }
}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

/* UPDATE CART START REQUEST */
document.addEventListener("liquid-ajax-cart:request-start", function (event) {
  const cart = document.querySelector("[data-js-cart]");
  cart?.setAttribute("inert", "");
  const { requestState } = event.detail;

  // Print the requestState before the request is performed
  console.log(requestState?.info?.initiator || "no initiator");

  if (
    requestState?.info &&
    requestState?.info?.initiator &&
    requestState?.info?.initiator?.href
  ) {
    const link = document.querySelector(
      `[href="${requestState?.info?.initiator?.href}"]`
    );
    // console.log(
    //   window.variantStrings.wait,
    //   requestState?.info?.initiator,
    //   `[href="${requestState?.info?.initiator?.href}"]`,
    //   link
    // );

    if (link) {
      // link?.innerText = window.variantStrings.wait;
    }

    return;
  }

  const error = document.querySelector("[data-js-error]");
  error?.setAttribute("hidden", "");

  // Make button say 'Adding...'
  const button = document.querySelector("[data-js-submit-cart]");

  if (button) {
    // Update button to say Adding...
    button.setAttribute("data-cta", button.innerText);
    button.innerText = window.variantStrings.addingToCart;
    button.setAttribute("aria-busy", true);
    button.setAttribute("disabled", "disabled"); // not ideal for a11y but fine until we get a better solution
  }
});

/* UPDATE CART END REQUEST */
document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  const cart = document.querySelector("[data-js-cart]");
  cart?.removeAttribute("inert");
  const { requestState } = event.detail;

  // console.log(requestState.responseData);

  // Revert button from saying 'Adding...'
  const button = document.querySelector("[data-js-submit-cart]");
  if (button) {
    button.innerText = button.getAttribute("data-cta");
    button.removeAttribute("aria-busy", true);
    button.removeAttribute("disabled");
    button.removeAttribute("aria-disabled");
  }

  // If the "add to cart" request is successful
  if (requestState.requestType === "add" && requestState.responseData?.ok) {
    updateCartCount();
    openCart();
  }

  // if the "update cart" was successful
  if (requestState.requestType === "change" && requestState.responseData?.ok) {
    if (!document.querySelector('body[data-test-cart-gamification="true"]')) {
      return;
    }
    const GAMI_DELAY_MS = 2000;
    const gami = document.querySelector("cart-gami");
    if (gami) {
      setTimeout(function () {
        gami.onInitCart();
        let gamiE = document.querySelector(".cart-drawer__gamification");
        if (gamiE) {
          gamiE.setAttribute("data-show", true);
        }
      }, GAMI_DELAY_MS);
    }
  }

  if (
    requestState.requestType === "add" &&
    requestState.responseData?.status === 400
  ) {
    if (
      requestState.responseData?.body.message === "Parameter Missing or Invalid"
    ) {
      if (button) {
        const x = document.querySelector(".product__select-title");
        x.setAttribute("tabindex", -1);
        x.focus();
        button.innerText = window.variantStrings.chooseASize;
        button.setAttribute("aria-disabled", "true");
      }
    }
  }
});
